import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow_w_line_left",
  "use": "arrow_w_line_left-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"arrow_w_line_left\"><path d=\"M20.314 19.334V5H22v14.334zM8.488 7.36c-.31-.336-.773-.336-1.082 0L3 12.168l4.406 4.806a.8.8 0 0 0 .54.253.8.8 0 0 0 .542-.253.867.867 0 0 0 0-1.18l-2.55-2.783h12.057c.464 0 .773-.337.773-.843s-.31-.843-.773-.843H5.937l2.55-2.783a.867.867 0 0 0 0-1.18\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol